import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
  ScrollView,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";
import {
  FontAwesome5,
  Feather,
  MaterialIcons,
  Octicons,
} from "@expo/vector-icons";
import Modal from "modal-react-native-web";
import { apiservice } from "../../service/service";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
const { width, height } = Dimensions.get("window");
export default function proflievip({ navigation, route }) {
  const [modal, setModal] = useState(false);
  const [user, setUser] = useState(route?.params?.item);
  const [data, setdata] = useState({});
  const [input, setInput] = useState("");
  const token = useRecoilValue(tokenState);
  const placeholder = {
    label: "Role",
    value: null,
    color: "#777777",
  };
  const [items, setItems] = useState([
    { label: "member", value: "member" },
    { label: "VIP", value: "VIP" },
  ]);
  const placeholder1 = {
    label: "Status",
    value: null,
    color: "#777777",
  };
  const [items1, setItems1] = useState([
    { label: "Active", value: "Active" },
    { label: "Block", value: "Block" },
  ]);

  console.log('====================================');
  console.log(user);
  console.log('====================================');

  async function getuserin() {
    const response = await apiservice({
      path: "/admin/getdataByuser?id=" + user.id,
      method: "get",
      token: token?.accessToken,
    });
    if (response.status == 200) {
      setdata(response.data);
    }
  }

  async function getuser() {
    const response = await apiservice({
      path: "/admin/getuser?id=" + user.id,
      method: "get",
      token: token?.accessToken,
    });

    if (response.status == 200) {
      setuser(response.data.data);
    }
  }

  useEffect(() => {
    getuserin();
    getuser();
  }, [focus]);

  return (
    <View style={styles.container}>
      <Modal
        animationType="slide"
        transparent={true}
        visible={modal}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModal(!modal);
        }}
      >
        <View style={styles.backmodal}>
          <View style={styles.viewmodal}>
            <Text style={styles.textdel}>
              พิมพ์คำว่า DELETE แล้วกดปุ่มยืนยัน เพื่อต้องการลบ ID นี้
            </Text>
            <TextInput defaultValue={input} onChangeText={setInput} style={styles.inputmodal} />
            <View
              style={{
                flexDirection: "row",
                marginTop: 20,
                alignSelf: "flex-end",
              }}
            >
              <TouchableOpacity style={styles.touchadd1}>
                <Text style={styles.textadd}>ยกเลิก</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={async () => {
                  if (input != 'DELETE') {
                    alert('กรุณาพิมพ์คำว่า DELETE ให้ถูกต้อง')
                    return
                  }

                  await apiservice({
                    path: "/admin/deleteaccount?id=" + user?.id,
                    method: "delete",
                    token: token.accessToken,
                  })

                  navigation.goBack()
                  setModal(!modal)
                }}
                style={[styles.touchadd1, { marginHorizontal: 25 }]}
              >
                <Text style={styles.textadd}>ยืนยัน</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <View style={styles.viewfree}>
            <Text style={styles.textfree}>
              USER{" "}
              <Text style={styles.textfree1}>
                / <Text style={styles.textfree1}>PROFILE</Text>
              </Text>
            </Text>

            <TouchableOpacity
              onPress={() => setModal(true)}
              style={[
                styles.touchadd,
                { backgroundColor: "#fff" },
                { marginLeft: 10 },
              ]}
            >
              <Text style={styles.textadd}>DELETE</Text>
            </TouchableOpacity>
          </View>
          <View style={[styles.viewfree, { marginTop: 20 }]}>
            <View style={[styles.viewfor]}>
              <View style={{ flexDirection: "row" }}>
                <View style={{ flexDirection: "row" }}>
                  <TouchableOpacity
                    style={{ justifyContent: "center", marginRight: 20 }}
                  >
                    <Image
                      style={{
                        width: 80,
                        height: 80,
                        justifyContent: "center",
                        marginTop: -20,
                      }}
                      source={{
                        uri:

                          user.image_Profile,
                      }}
                    />
                  </TouchableOpacity>
                  <View>
                    <Text style={[styles.textname, { marginTop: 10 }]}>
                      {user?.name}
                    </Text>
                    <Text style={styles.textname1}>
                      {user?.full_address?.province}, Thailand
                    </Text>
                  </View>
                </View>
                <View style={{ marginLeft: 30 }}>
                  <Text style={styles.textname2}>Email : {user?.email}</Text>
                  <Text style={styles.textname2}>
                    ID Code : {user?.id + 100000}
                  </Text>
                </View>
                <TouchableOpacity
                  style={{ justifyContent: "center", marginLeft: 40 }}
                >
                  <Image
                    style={{
                      width: 80,
                      height: 100,
                      alignSelf: "center",
                      justifyContent: "center",
                    }}
                    source={require("../../image/vip.png")}
                  />
                </TouchableOpacity>
              </View>
              <View style={{ flexDirection: "row" }}>
                <Image
                  style={{
                    width: 28,
                    height: 35,
                    alignSelf: "center",
                    marginRight: 5,
                  }}
                  source={require("../../image/Icon awesome-running.png")}
                />
                <Text style={styles.textdate}>0</Text>
                <Image
                  style={{
                    width: 35,
                    height: 35,
                    alignSelf: "center",
                    marginRight: 5,
                  }}
                  source={require("../../image/coin.png")}
                />
                <Text style={styles.textdate}>0</Text>
              </View>
            </View>
            <View style={{ width: width * 0.23 }}>
              <Text style={styles.textname}>Role</Text>
              <Text style={styles.textname1}>VIP</Text>
              <Text style={[styles.textname, { marginTop: 10 }]}>Status</Text>
              <View style={{ flexDirection: "row" }}>
                <Octicons
                  name="primitive-dot"
                  size={16}
                  color="#2DCE98"
                  style={{ alignSelf: "center", marginRight: 10 }}
                />
                <Text style={styles.textname1}>Active</Text>
              </View>
              {/* <RNPickerSelect
                placeholder={placeholder1}
                style={{
                  inputWeb: {
                    width: width * 0.23,
                    height: 30,
                    borderWidth: 1,
                    borderColor: "#ccc",
                    paddingLeft: 10,
                    borderRadius: 5,
                    color: "#777777",
                    fontFamily: "Prompt-Regular",
                    alignSelf: "center",
                  },
                }}
                items={items1}
              /> */}
            </View>
          </View>
          <Text style={styles.textfree2}>SHIPPING ADDRESS</Text>
          <View style={[styles.view, { marginBottom: 30 }]}>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>ชื่อ</Text>
              <TextInput value={user?.name} style={styles.inputadd} />
            </View>
            {/* <View style={styles.viewmainfor}>
              <Text style={styles.textname}>นามสกุล</Text>
              <TextInput style={styles.inputadd} />
            </View> */}
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>เบอร์โทรศัพท์</Text>
              <TextInput value={user?.tel} style={styles.inputadd} />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>ที่อยู่</Text>
              <TextInput
                onChangeText={async (text) => {
                  setUser({
                    ...user,
                    full_address: {
                      ...user?.full_address,
                      ShippingAddress: text,
                    },
                  });
                  const response = await apiservice({
                    path: "/admin/edit-profile",
                    method: "put",
                    body: {
                      ...user,
                      full_address: {
                        ...user?.full_address,
                        ShippingAddress: text,
                      },
                    },
                    token: token.accessToken,
                  });

                  if (response?.status == 200) {
                  }
                }}
                value={user?.full_address?.ShippingAddress}
                multiline
                style={styles.inputadd1}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>แขวง (ตำบล)</Text>
              <TextInput
                onChangeText={async (text) => {
                  setUser({
                    ...user,
                    full_address: {
                      ...user?.full_address,
                      subDistrict: text,
                    },
                  });
                  const response = await apiservice({
                    path: "/admin/edit-profile",
                    method: "put",
                    body: {
                      ...user,
                      full_address: {
                        ...user?.full_address,
                        subDistrict: text,
                      },
                    },
                    token: token.accessToken,
                  });

                  if (response?.status == 200) {
                  }
                }}
                value={user?.full_address?.subDistrict}
                style={styles.inputadd}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>เขต (อำเภอ)</Text>
              <TextInput
                onChangeText={async (text) => {
                  setUser({
                    ...user,
                    full_address: {
                      ...user?.full_address,
                      district: text,
                    },
                  });
                  const response = await apiservice({
                    path: "/admin/edit-profile",
                    method: "put",
                    body: {
                      ...user,
                      full_address: {
                        ...user?.full_address,
                        district: text,
                      },
                    },
                    token: token.accessToken,
                  });

                  if (response?.status == 200) {
                  }
                }}
                value={user?.full_address?.district}
                style={styles.inputadd}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>จังหวัด</Text>
              <TextInput
                onChangeText={async (text) => {
                  setUser({
                    ...user,
                    full_address: {
                      ...user?.full_address,
                      province: text,
                    },
                  });
                  const response = await apiservice({
                    path: "/admin/edit-profile",
                    method: "put",
                    body: {
                      ...user,
                      full_address: {
                        ...user?.full_address,
                        province: text,
                      },
                    },
                    token: token.accessToken,
                  });

                  if (response?.status == 200) {
                  }
                }}
                value={user?.full_address?.province}
                style={styles.inputadd}
              />
            </View>
            <View style={styles.viewmainfor}>
              <Text style={styles.textname}>รหัสไปรษณีย์</Text>
              <TextInput
                onChangeText={async (text) => {
                  setUser({
                    ...user,
                    full_address: {
                      ...user?.full_address,
                      postcode: text,
                    },
                  });
                  const response = await apiservice({
                    path: "/admin/edit-profile",
                    method: "put",
                    body: {
                      ...user,
                      full_address: {
                        ...user?.full_address,
                        postcode: text,
                      },
                    },
                    token: token.accessToken,
                  });

                  if (response?.status == 200) {
                  }
                }}
                value={user?.full_address?.postcode}
                style={styles.inputadd}
              />
            </View>
          </View>
          <View style={[styles.viewfree, { marginBottom: 20 }]}>
            <TouchableOpacity
              onPress={() => navigation.navigate("EventList", user)}
              style={styles.viewevent}
            >
              <View>
                <Text style={styles.text}>COMPLETE</Text>
                <Text style={styles.text1}>{data.complete}</Text>
              </View>
              <View style={[styles.imgicon, { backgroundColor: "#2DCE98" }]}>
                <FontAwesome5
                  name="user-alt"
                  size={25}
                  color="#fff"
                  style={{ alignSelf: "center" }}
                />
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => navigation.navigate("EventList", user)}
              style={styles.viewevent}
            >
              <View>
                <Text style={styles.text}>EVENT</Text>
                <Text style={styles.text1}>{data?.event}</Text>
              </View>
              <View style={[styles.imgicon, { backgroundColor: "#2DCE98" }]}>
                <Feather
                  name="file-text"
                  size={25}
                  color="#fff"
                  style={{ alignSelf: "center" }}
                />
              </View>
            </TouchableOpacity>
            <TouchableOpacity style={styles.viewevent}>
              <View>
                <Text style={styles.text}>FREE POINT</Text>
                <Text style={styles.text1}>{data.freepoint}</Text>
              </View>
              <View style={[styles.imgicon, { backgroundColor: "#7764E4" }]}>
                <FontAwesome5
                  name="coins"
                  size={24}
                  color="#fff"
                  style={{ alignSelf: "center" }}
                />
              </View>
            </TouchableOpacity>
            <View style={styles.viewevent}>
              <View>
                <Text style={styles.text}>DISCOUNT</Text>
                <Text style={styles.text1}>{data.discount}</Text>
              </View>
              <View style={[styles.imgicon, { backgroundColor: "#7764E4" }]}>
                <MaterialIcons
                  name="card-giftcard"
                  size={24}
                  color="#fff"
                  style={{ alignSelf: "center" }}
                />
              </View>
            </View>
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.82,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    alignSelf: "center",
  },
  touchadd1: {
    width: 150,
    height: 40,
    justifyContent: "center",
    alignSelf: "center",
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewfor: {
    width: width * 0.55,
    height: 150,
    backgroundColor: "#FFF",
    padding: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    borderRadius: 10,
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  textname1: {
    fontSize: 16,
    color: "#444444",
    fontFamily: "Prompt-Regular",
  },
  textname2: {
    fontSize: 16,
    color: "#000",
    fontFamily: "Prompt-Regular",
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  textfree2: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    marginTop: 10,
  },
  view: {
    width: width * 0.82,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    paddingHorizontal: 10,
    paddingVertical: 20,
    borderRadius: 10,
  },
  viewmainfor: {
    flexDirection: "row",
    width: width * 0.3,
    justifyContent: "space-between",
  },
  inputadd: {
    width: width * 0.16,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  inputadd1: {
    width: width * 0.16,
    height: 100,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  viewevent: {
    width: width * 0.2,
    height: 100,
    backgroundColor: "#fff",
    borderRadius: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    padding: 20,
  },
  imgicon: {
    width: 50,
    height: 50,
    alignSelf: "flex-end",
    justifyContent: "center",
    borderRadius: 25,
    marginTop: -50,
  },
  text: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#8898AA",
  },
  text1: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#4D4F5C",
  },
  backmodal: {
    flex: 1,
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  viewmodal: {
    width: width * 0.7,
    height: 250,
    backgroundColor: "#fff",
    borderRadius: 5,
    alignSelf: "center",
    padding: 10,
  },
  textdel: {
    fontFamily: "Prompt-Regular",
    fontSize: 35,
    color: "#000",
    alignSelf: "center",
  },
  inputmodal: {
    width: width * 0.65,
    height: 50,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginVertical: 10,
    alignSelf: "center",
  },
});
